import React, { useEffect } from 'react';
import DOMPurify from 'dompurify';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
};
const OurServiceSection = ({ sliderData, popup, data }) => {
    useEffect(() => {
        const swiperMap = {
            tab1: window.swiper1,
            tab2: window.swiper2,
            tab3: window.swiper3,
            tab4: window.swiper4,
        };

        const swiper1 = new Swiper('.mySwiper1, .mySwiper2, .mySwiper3, .mySwiper4', {
            modules: [Navigation, Pagination],
            slidesPerView: 4,
            spaceBetween: 30,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                1060: {
                    slidesPerView: 4,
                    spaceBetween: 20
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 15
                },
                480: {
                    slidesPerView: 1,
                    spaceBetween: 10
                },
                100: {
                    slidesPerView: 1,
                    spaceBetween: 10
                }
            },
        });
    }, []);

    return (
        <section className="services_sec services_sec_post_page">
            <div className="service_page_slide_main" id="sky47_space">
                <h4 className="head">{data?.sky47_space_heading}</h4>
                <p className="para">{data?.sky47_space_paragraph}</p>
                <div className="swiper mySwiper1">
                    <div className="swiper-wrapper">
                        {sliderData
                            ?.filter((item) =>
                                item?.class_list?.includes('services_category-sky47-space')
                            )
                            .map((item) => (
                                <div className="swiper-slide" key={item.id}>
                                    <div className="frame-group-wrapper">
                                        <div className="frame-group">
                                            <div className="frame-ellipse"></div>
                                            <div className="frame-div"></div>
                                            <div className="frame-ellipse-2"></div>
                                        </div>
                                    </div>
                                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item?.acf?.post_icon || "") }} className="box_img_left">
                                    </div>
                                    <div className="box_content_right">
                                        <h4>{item?.title?.rendered}</h4>
                                        <p>{stripHtml(item?.content?.rendered)}</p>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>

            <div className="service_page_slide_main" id="sky47_cloud">
                <h4 className="head">{data?.sky47_cloud_heading}</h4>
                <p className="para">{data?.sky47_cloud_paragraph}</p>
                <div className="swiper mySwiper2">
                    <div className="swiper-wrapper">
                        {sliderData
                            ?.filter((item) =>
                                item?.class_list?.includes('services_category-sky47-cloud')
                            )
                            .map((item) => (
                                <div className="swiper-slide" key={item.id}>
                                    <div className="frame-group-wrapper">
                                        <div className="frame-group">
                                            <div className="frame-ellipse"></div>
                                            <div className="frame-div"></div>
                                            <div className="frame-ellipse-2"></div>
                                        </div>
                                    </div>
                                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item?.acf?.post_icon || "") }} className="box_img_left">
                                    </div>
                                    <div className="box_content_right">
                                        <h4>{item?.title?.rendered}</h4>
                                        <p>{stripHtml(item?.content?.rendered)}</p>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>

            <div className="service_page_slide_main" id="sky47_secure">
                <h4 className="head">{data?.sky47_secure_heading}</h4>
                <p className="para">{data?.sky47_secure_paragraph}</p>
                <div className="swiper mySwiper3">
                    <div className="swiper-wrapper">
                        {sliderData
                            ?.filter((item) =>
                                item?.class_list?.includes('services_category-sky47-secure')
                            )
                            .map((item) => (
                                <div className="swiper-slide" key={item.id}>
                                    <div className="frame-group-wrapper">
                                        <div className="frame-group">
                                            <div className="frame-ellipse"></div>
                                            <div className="frame-div"></div>
                                            <div className="frame-ellipse-2"></div>
                                        </div>
                                    </div>
                                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item?.acf?.post_icon || "") }} className="box_img_left">
                                    </div>
                                    <div className="box_content_right">
                                        <h4>{item?.title?.rendered}</h4>
                                        <p>{stripHtml(item?.content?.rendered)}</p>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>

            <div className="service_page_slide_main" id="sky47_manage">
                <h4 className="head">{data?.sky47_manage_heading}</h4>
                <p className="para">{data?.sky47_manage_paragraph}</p>
                <div className="swiper mySwiper4">
                    <div className="swiper-wrapper">
                        {sliderData
                            ?.filter((item) =>
                                item?.class_list?.includes('services_category-sky47-manage')
                            )
                            .map((item) => (
                                <div className="swiper-slide" key={item.id}>
                                    <div className="frame-group-wrapper">
                                        <div className="frame-group">
                                            <div className="frame-ellipse"></div>
                                            <div className="frame-div"></div>
                                            <div className="frame-ellipse-2"></div>
                                        </div>
                                    </div>
                                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item?.acf?.post_icon || "") }} className="box_img_left">
                                    </div>
                                    <div className="box_content_right">
                                        <h4>{item?.title?.rendered}</h4>
                                        <p>{stripHtml(item?.content?.rendered)}</p>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>

            <div className="services_post_btn services_post_btn_floating">
                <a className="white_btn" onClick={() => popup(true)}>
                    {data?.services_page_floating_button_text}
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20" fill="none">
                        <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="black" />
                        <path d="M13.5211 12.7727L13.298 7.10815C13.2915 7.00261 13.2643 6.89775 13.2179 6.79958C13.129 6.60182 12.9682 6.44104 12.7705 6.35212C12.6723 6.30574 12.5675 6.27855 12.4619 6.27209L6.79738 6.04892C6.69175 6.04476 6.58797 6.06145 6.49198 6.09803C6.39598 6.1346 6.30964 6.19036 6.23789 6.26211C6.09299 6.40701 6.0163 6.60827 6.02471 6.8216C6.03311 7.03493 6.12592 7.24286 6.28271 7.39965C6.4395 7.55644 6.64743 7.64925 6.86076 7.65765L10.5935 7.79906L5.91933 12.4732C5.77502 12.6175 5.69864 12.8179 5.70701 13.0304C5.71539 13.2429 5.80781 13.4499 5.96396 13.6061C6.12012 13.7623 6.3272 13.8547 6.53966 13.863C6.75212 13.8714 6.95256 13.795 7.09687 13.6507L11.771 8.9766L11.9124 12.7093C11.9161 12.815 11.9408 12.9206 11.9849 13.02C12.029 13.1194 12.0918 13.2106 12.1695 13.2883C12.2472 13.366 12.3384 13.4287 12.4378 13.4729C12.5371 13.517 12.6427 13.5416 12.7485 13.5454C12.8542 13.55 12.9582 13.5336 13.0544 13.4972C13.1506 13.4607 13.2371 13.405 13.309 13.3332C13.3808 13.2613 13.4365 13.1748 13.4729 13.0786C13.5094 12.9824 13.5257 12.8785 13.5211 12.7727Z" fill="black" />
                    </svg>
                </a>
            </div>

        </section>
    );
};

export default OurServiceSection;